var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearchCustomer = function SvgSearchCustomer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5294_4483)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.47851 8.45893C5.6596 9.51895 6.31368 10.0902 6.98224 10.0914C7.65081 10.0902 8.30488 9.51895 8.48598 8.45893C8.66725 7.39784 8.15508 6.5 6.98428 6.5C5.81347 6.5 5.29723 7.39784 5.47851 8.45893Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.02093 12.8655C4.03967 12.7645 4.06194 12.6645 4.08842 12.5695C4.19625 12.1827 5.38223 11.314 6.20683 10.7484C6.68963 10.4172 7.31037 10.4172 7.79317 10.7484C8.61777 11.314 9.80375 12.1827 9.91158 12.5695C9.93806 12.6645 9.96033 12.7645 9.97907 12.8655C10.1003 13.5192 9.6821 14.1214 9.0581 14.2631C8.51735 14.3859 7.79976 14.5 7 14.5C6.20024 14.5 5.48265 14.3859 4.9419 14.2631C4.3179 14.1214 3.89971 13.5192 4.02093 12.8655Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5C0 3.89543 0.895431 3 2 3H26C27.1046 3 28 3.89543 28 5V11.275C27.9553 11.2283 27.9099 11.182 27.864 11.136C24.3492 7.62132 18.6508 7.62132 15.136 11.136C13.3158 12.9563 12.4382 15.3622 12.5034 17.7472C12.5011 17.8303 12.5 17.9145 12.5 18H2C0.895431 18 0 17.1046 0 16V5ZM2 6C2 5.44772 2.44772 5 3 5H11C11.5523 5 12 5.44772 12 6V15C12 15.5523 11.5523 16 11 16H3C2.44772 16 2 15.5523 2 15V6Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5942 23.9155C22.6757 25.775 18.7582 25.4304 16.21 22.8819C13.2633 19.935 13.2633 15.1571 16.21 12.2102C19.1566 9.26327 23.934 9.26327 26.8806 12.2102C29.4289 14.7588 29.7734 18.6768 27.914 21.5956L31.5197 25.2017C32.1603 25.8423 32.1603 26.881 31.5197 27.5216C30.8791 28.1623 29.8406 28.1623 29.2 27.5216L25.5942 23.9155ZM25.0052 21.0455C25.0116 21.0389 25.018 21.0323 25.0245 21.0258C25.0311 21.0193 25.0376 21.0128 25.0443 21.0064C26.9465 19.083 26.94 15.9815 25.0248 14.0661C23.1031 12.1442 19.9874 12.1442 18.0657 14.0661C16.144 15.988 16.144 19.1041 18.0657 21.026C19.9809 22.9413 23.0819 22.9478 25.0052 21.0455Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5294_4483"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
};
export default SvgSearchCustomer;